import { Card } from "primereact/card";
import { Toast } from "primereact/toast";

import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { IClientContactPerson } from "../../../../../models/ClientContactPerson";
import { IDesignationMastDropdown } from "../../../../../models/IDropdown";
import { Fetch } from "../../../../../shared/Fetch";
import { JVInput } from "../../../../../shared/JVInput";
import { JVDropdown } from "../../../../../shared/JVDropdown";
import { JVInputMask } from "../../../../../shared/JVInputMask";


interface IProps {
    open: boolean,
    singleData: any,
    hideDialog: () => void,
    toast: any,
    reload1: boolean,
    setReload: (is: boolean) => void,
}

const schema = yup.object({
    contact_Person_EmailID: yup.string().required("EmailID is required*").email(),
    // vendor_Company: yup.object().shape({
    //     vendor_Company_ID: yup.number().min(1, "Client Company Name is required*").required("Client Company Name is required*"),
    //     vendor_Company_Name: yup.string().required(),
    //     website_URL: yup.string()
    // }).typeError("Client Company Name is required"),
    contact_Person_Name: yup.string().required("Name is required*").min(3),
    designation: yup.number().min(1, "Designation is required*").required("Designation is required*"),
    phone_No: yup.string().required("Phone No is required*"),
    ext: yup.string().nullable(),
    cell_No: yup.string().nullable(),
    major_Technology: yup.string().nullable()
});

export const SubCendorPOCDetails = (props: IProps) => {
    const [data, setData] = useState<IClientContactPerson>();
    const [loading, setLoading] = useState<boolean>(false);
    const [designations, setDesignations] = useState<Array<IDesignationMastDropdown>>();
    const toast = useRef<any>(null);

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch, } = useForm<IClientContactPerson>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    const loadDesignations = async () => {
        const response = await Fetch("Dropdown/designation", "GET", null, null, null);
        if (response) {
            const data: Array<IDesignationMastDropdown> = await response.json();
            setDesignations(data);
        }
    };

    const saveToDB = async (body: IClientContactPerson) => {
        setLoading(true);
        // const method = (data?.contact_Person_ID != undefined && data?.contact_Person_ID != null) ? "PUT" : "POST";
        const method = "PUT";
        const message = (data?.contact_Person_ID != undefined && data?.contact_Person_ID != null) ? "Updated Successfully" : "Added Successfully";

        body.vendor_Company_ID = body.vendor_Company?.vendor_Company_ID;
        delete body.vendor_Company;

        let newBody: IClientContactPerson = {}

        newBody.contact_Person_ID = body.contact_Person_ID;
        newBody.vendor_Company_ID = body.vendor_Company_ID;
        newBody.contact_Person_EmailID = body.contact_Person_EmailID;
        newBody.contact_Person_Name = body.contact_Person_Name;
        newBody.designation = body.designation;
        newBody.phone_No = body.phone_No;
        newBody.cell_No = body.cell_No;
        newBody.major_Technology = body.major_Technology;
        newBody.add_by_User = body.add_by_User;
        newBody.blackListed_Status = body.blackListed_Status;
        newBody.ext = body.ext;
        newBody.vendor_Company_ID = data?.vendor_Company_ID;
        //newBody.add_Date = body.Add_Date;
        //newBody.hotlist_Send = body.Hotlist_Send;
        //newBody.Updated_By = body.Updated_By;
        //newBody.Updated_At = body.Updated_At;
        //newBody.Disable_Share_PV = body.Disable_Share_PV;

        const response = await Fetch("ResourceSub_Vendor_Contact_Person_Mast", method, newBody, null, toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            // props.setReload(!props.reload);
            props.hideDialog();
            props.setReload(!props.reload1);
            setLoading(false);
        } else setLoading(false);
    };

    function onSubmit(data: IClientContactPerson) {
        const e_domain = data.contact_Person_EmailID?.split("@")[1];
        if (!(e_domain?.includes("gmail") || e_domain?.includes("outlook")
            || e_domain?.includes("protonmail") || e_domain?.includes("aol")
            || e_domain?.includes("yahoo") || e_domain?.includes("hotmail")
            || e_domain?.includes("rediff"))) {
            saveToDB(data);
        }
        else toast.current.show({ severity: 'error', detail: "Contact Person Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc.", life: 3000 });
    };

    const onHide = () => {
        // props.hideDialog();
        // reset(EmptyClientContactPerson);
        // setVCompanyInfo(undefined);
    };
console.log(props?.singleData?.contact_Person_Name)
    useEffect(() => {
        if (props?.singleData?.contact_Person_ID) {
            let newData = props?.singleData;
            newData.vendor_Company_ID = props?.singleData?.vendor_Company_ID;
            newData.phone_No = props?.singleData?.contact_Person_Phone_No;
            reset(newData);
        }
    }, [props?.singleData]);

    useEffect(() => {
        loadDesignations();
    }, []);

    return (
        <>
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVInput required label="Email ID" disabled control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />

                    {/* <JVDropdownInput required completeMethod={completeMethod} label="Client Company Name" control={control} name="vendor_Company" error={errors.vendor_Company?.message} options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client Company" /> */}
                    <div className={'field col-12 md:col-6'}>
                        <label>Company Name</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{props.singleData.vendor_Company_Name}</p>
                    </div>

                    <JVInput required label="Name" control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                    <JVDropdown required label="Designation" control={control} name="designation" error={errors.designation?.message} options={designations} optionLabel="designation_Name" optionValue="designationId" placeholder="Select Designation" />
                    <JVInputMask mask="(999) 999-9999" required label="Phone No" control={control} name="phone_No" error={errors.phone_No?.message} />
                    <JVInput label="Ext." control={control} name="ext" error={errors.ext?.message} />
                    <JVInputMask mask="(999) 999-9999" label="Cell No" control={control} name="cell_No" error={errors.cell_No?.message} />
                    {/* <JVInput label="Major Technology" control={control} name="major_Technology" error={errors.major_Technology?.message} /> */}

                    <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-3">
                        <Button loading={loading} style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                        <Button style={{ width: '100px' }} label="CLEAR" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                    </div>

                </form>
            </Card>
            <Toast ref={toast} />
        </>
    );
}